export const TAXONOMY_SKIP_SEGMENT = 'all';

export const taxonomyAttributeToFacetKey = (attribute: string): string => {
  return `attributes.${attribute}`;
};

export const levelsToPageCategories = (taxonomyLevelValues: string[]): string[] => [
  taxonomyLevelValues
    .filter((v) => v !== TAXONOMY_SKIP_SEGMENT)
    .map((v) => v.split(',').join('/'))
    .join(' > '),
];
